// extracted by mini-css-extract-plugin
export default {"container":"ImageWithMessage_container__bfOPZ","img":"ImageWithMessage_img__qHS9O","title":"ImageWithMessage_title__zXtUN","text":"ImageWithMessage_text__qafEX"};